import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  update(event) {
    if (!this.hasSelectTarget) return

    const rawOptions = event.detail.selected.dataset.consumptionUnits
    if (!rawOptions) return

    const selectedValue = this.selectTarget.value
    const options = JSON.parse(rawOptions)
    this.selectTarget.replaceChildren(
      ...options.map(({ value, label }) => new Option(label, value))
    )

    if (options.some(({ value }) => value === selectedValue)) {
      this.selectTarget.value = selectedValue
    }
  }
}
